import { Box, Tooltip } from "@mui/material";
import React from "react";
import { path } from "src/constants/path";
import {
  allowedToDeleteEntity,
  allowedToUpdateEntity,
} from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { deviceColumns as columns, showHomePageOption } from "../../Helper";
import { Link } from "react-router-dom";
import Controls from "src/components/form/controls/Controls";

const GetDeviceColumns = ({ handleDelete, handleShowHomePage, status }) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const showHomePageCol = {
    key: "showOnHomepage",
    label: "Show On Homepage",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <Controls.Select
            name="isShowHomePage"
            value={item.isShowHomePage ? "show" : "hide"}
            onChange={handleShowHomePage(item)}
            options={showHomePageOption}
          />
        )}
      </Box>
    ),
  };

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <Link
            to={{
              pathname: `${path.flfDevice}/edit/${item.id}`,
              //   state: { page: page, categoryId: categoryId, limit: limit },
            }}
          >
            <Tooltip title="Edit">
              <button className="btn btn-warning">
                <i className="bx bx-edit"></i>
              </button>
            </Tooltip>
          </Link>
        )}
        {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
          <Tooltip title="Delete">
            <button
              className="btn btn-danger"
              onClick={() => handleDelete(item.id)}
            >
              <i className="bx bx-trash"></i>
            </button>
          </Tooltip>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, showHomePageCol, actionCol];
  }

  return columns;
};

export default GetDeviceColumns;
